const Console = () => {
    window.location.replace("https://t.me/alerte_console");
    return (
        null
    );

}

export default Console;